import type { ApiPiece } from "@/hooks/use-projects";
import { StatusBadge } from "@/components/ui/status-badge";

const STATUS_ORDER = [
  "DRAFT",
  "PENDING_REVIEW",
  "APPROVED",
  "REJECTED",
  "SCHEDULED",
  "PUBLISHED",
  "FAILED",
] as const;

/**
 * Compact per-status piece counts for a project — the "progress" companion
 * to the PipelineStageIndicator. Statuses with zero pieces are omitted.
 */
export function PieceStatusSummary({ pieces }: { pieces: ApiPiece[] }) {
  if (pieces.length === 0) return null;

  const counts = new Map<string, number>();
  for (const piece of pieces) {
    counts.set(piece.status, (counts.get(piece.status) ?? 0) + 1);
  }

  return (
    <div className="flex flex-wrap items-center gap-3">
      {STATUS_ORDER.filter((s) => (counts.get(s) ?? 0) > 0).map((status) => (
        <span key={status} className="flex items-center gap-1.5">
          <StatusBadge status={status} />
          <span className="text-xs text-muted-foreground tabular-nums">
            {counts.get(status)}
          </span>
        </span>
      ))}
    </div>
  );
}
